import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
import { cn } from "../lib/utils";

interface TruncatedTextProps {
  text: string;
  className?: string;
  /** Maximum lines before truncation (default: 1) */
  maxLines?: 1 | 2 | 3;
  /** Show tooltip on hover (default: true) */
  showTooltip?: boolean;
}

/**
 * A text component that truncates long text with ellipsis and shows
 * the full text in a tooltip on hover.
 */
export function TruncatedText({
  text,
  className,
  maxLines = 1,
  showTooltip = true,
}: TruncatedTextProps) {
  const lineClampClass = {
    1: "truncate",
    2: "line-clamp-2",
    3: "line-clamp-3",
  }[maxLines];

  const content = (
    <span
      className={cn("block", "min-w-0", lineClampClass, className)}
      title={!showTooltip ? text : undefined}
    >
      {text}
    </span>
  );

  if (!showTooltip) return content;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent side="top" className="max-w-[300px] break-words">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
